import { Link } from 'react-router-dom';
import { PenLine, Image, Clapperboard, Globe, Workflow, Timer, BookOpen, TrendingUp } from 'lucide-react';
import { trackHome } from '@/lib/homeAnalytics';

// Each goal maps to an existing category page (or a free classic search when no matching category exists).
const GOALS = [
  { icon: PenLine, title: 'Create content', to: '/categories/writing', id: 'writing' },
  { icon: Image, title: 'Generate images', to: '/categories/image-generation', id: 'image-generation' },
  { icon: Clapperboard, title: 'Make videos', to: '/categories/video', id: 'video' },
  { icon: Globe, title: 'Build websites', to: '/categories/vibe-coding', id: 'vibe-coding' },
  { icon: Workflow, title: 'Automate work', to: '/search?q=automation&ai=false', id: 'automation' },
  { icon: Timer, title: 'Improve productivity', to: '/categories/productivity', id: 'productivity' },
  { icon: BookOpen, title: 'Research and learn', to: '/categories/research', id: 'research' },
  { icon: TrendingUp, title: 'Grow a business', to: '/categories/marketing', id: 'marketing' },
];

export function GoalDiscovery() {
  return (
    <section className="border-b border-border/60">
      <div className="container mx-auto px-4 py-8 md:py-10">
        <div className="max-w-6xl mx-auto">
          <h2 className="font-display text-xl md:text-2xl font-semibold tracking-tight mb-5">
            What are you trying to accomplish?
          </h2>
          <nav aria-label="Discover by goal" className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-3">
            {GOALS.map((g) => (
              <Link
                key={g.id}
                to={g.to}
                onClick={() => trackHome('goal_selected', g.id)}
                className="group flex flex-col items-center justify-center gap-2 text-center rounded-2xl border border-border/60 bg-card px-3 py-4 min-h-[96px] hover:border-primary/50 hover:bg-primary/5 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-primary"
              >
                <span className="h-10 w-10 rounded-xl bg-primary/10 flex items-center justify-center group-hover:bg-primary/15 transition-colors">
                  <g.icon className="h-5 w-5 text-primary" aria-hidden />
                </span>
                <span className="text-sm font-medium leading-tight">{g.title}</span>
              </Link>
            ))}
          </nav>
        </div>
      </div>
    </section>
  );
}
